import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31360ab1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tile-kebab-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm glyphicon glyphicon-option-vertical" }, null, -1))

import { Dropdown, Btn } from "uiv";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tile-kebab-menu',
  emits: ["openKebab", "closeKebab"],
  setup(__props, { expose: __expose, emit: __emit }) {

const show = ref(false);

const emit = __emit;

const onKebabClick = () => {
  if (!show.value) {
    emit("openKebab");
  }
};

__expose({
  close: () => {
    show.value = false;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Dropdown), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      "menu-right": ""
    }, {
      dropdown: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Btn), {
          type: "link",
          class: _normalizeClass(["dropdown-toggle btn-close-background-only", { 'dropdown-selected': show.value }]),
          onClick: [
            _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
            onKebabClick
          ]
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}
}

})